import React from 'react';
import OfferCardStat from '../OfferStat';
import { PromoterOfferDto } from 'legacy/events/types';

const OfferCard = ({
  offer
}: // handleMoreActions
{
  offer: PromoterOfferDto;
  // handleMoreActions: () => void;
}) => (
  // const hanleClick = (e) => {
  //   e.stopPropagation();
  //   handleMoreActions();
  // };
  <div className="border-1 border-[#EBEBEB] rounded-lg">
    <div className="p-4">
      <div className="flex flex-row items-center justify-between">
        <div className="font-bold text-base">{offer.name}</div>
        {/* <BsThreeDots
            className="text-[#787878]"
            size={20}
            onClick={hanleClick}
          /> */}
      </div>
      <div className="flex items-center gap-2">
        <div className="text-sm font-normal py-4">🗣️</div>
        <div className="text-sm font-normal py-4 text-[#202020]">
          {offer.activePromoters} Active Promoters
        </div>
      </div>
      {/* <div className="flex items-center justify-center gap-2 border border-[#EFF2FF] rounded-2xl p-2">
          <div className="text-sm font-bold text-[#3853C4]">Pause Offer</div>
          <IoMdPause className="text-[#3853C4]" />
        </div> */}
    </div>
    <div className="h-[1px] bg-[#EBEBEB] w-full" />
    <div className="flex flex-row items-center p-4">
      <OfferCardStat
        title="Views"
        description={offer.analytics?.views?.toString() || '0'}
      />
      <OfferCardStat
        title="Sales"
        description={offer.analytics?.sales?.toString() || '0'}
      />
      {/* <OfferCardStat title="Revenue" description="$1,200" />
        <OfferCardStat title="Earnings" description="$10,000" /> */}
    </div>
  </div>
);
export default OfferCard;
